module.exports = __webpack_public_path__ + "Roboto-LightItalic.1d77cf804e1c37bcb4bd.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-LightItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-LightItalic.woff
// module chunks = styles